import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, CertificateValidate } from './types';

export const INITIAL_STATE: CertificateValidate = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CertificateValidate {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CERTIFICATE_VALIDATE_REQUEST: {
				break;
			}

			case Types.CERTIFICATE_VALIDATE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CERTIFICATE_VALIDATE_FAILURE: {
				draft.status = 400;
				draft.data = null;
				break;
			}

			case Types.CERTIFICATE_VALIDATE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
